import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import Table from '../../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { tollLiquidationPropTypes } from '../proptypes/TollLiquidationPropTypes';
import { numberFormatter } from '../../../../../utils/number';
import {
  TOLL_LIQUIDATION_DETAIL_COLUMNS,
  TOLL_LIQUIDATION_ADDITIONAL_CHARGE_COLUMNS,
} from '../../../../../config/columns';

const TollLiquidationBasicInformationResource = ({
  id,
  itineraryId,
  itineraryDepartureTime,
  routeName,
  circuitName,
  totalAmount,
  tollLiquidateAmount,
  differenceAmount,
  differenceReason,
  observation,
  registeredBus,
  payeeCustomer,
  originalPayeeCustomer,
  tollLiquidationDetailList = [],
  tollLiquidationAdditionalChargeList = [],
  createDate,
}) => (
  <>
    <h3>Información General</h3>

    <ResourceProperty label="Ruta: ">{routeName || '-'}</ResourceProperty>

    <ResourceProperty label="Circuito: ">{circuitName || '-'}</ResourceProperty>

    <ResourceProperty label="Fecha de Salida: ">
      {itineraryDepartureTime
        ? tzNormalizeDate({
            date: itineraryDepartureTime,
            format: DATE_TIME_FORMAT,
          })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Bus: ">
      {registeredBus
        ? `${registeredBus.companyBusId} - ${registeredBus.licensePlate}`
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Conductor que Recibió: ">
      {originalPayeeCustomer ? originalPayeeCustomer.fullName : '-'}
    </ResourceProperty>

    <ResourceProperty label="Conductor Liquidador: ">
      {payeeCustomer ? payeeCustomer.fullName : '-'}
    </ResourceProperty>

    <ResourceProperty label="Total a Liquidar: ">
      {numberFormatter({ value: totalAmount })}
    </ResourceProperty>

    <ResourceProperty label="Monto Liquidado: ">
      {numberFormatter({ value: tollLiquidateAmount })}
    </ResourceProperty>

    <ResourceProperty label="Monto de Discrepancia: ">
      {numberFormatter({ value: differenceAmount })}
    </ResourceProperty>

    <ResourceProperty label="Razón de Discrepancia: ">
      {differenceReason ? differenceReason.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Observación: ">
      {observation || '-'}
    </ResourceProperty>

    <h3 className="mt-4">Detalle de Peajes</h3>

    {tollLiquidationDetailList.length > 0 ? (
      <Table
        columns={TOLL_LIQUIDATION_DETAIL_COLUMNS}
        data={tollLiquidationDetailList}
        defaultPageSize={
          tollLiquidationDetailList.length <= 10
            ? tollLiquidationDetailList.length
            : DEFAULT_PAGE_SIZE
        }
        showPagination={tollLiquidationDetailList.length > 10}
        manual={false}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
    ) : (
      <div className="alert alert-info">No existen peajes registrados.</div>
    )}

    <h3 className="mt-4">Cargos Adicionales</h3>

    {tollLiquidationAdditionalChargeList.length > 0 ? (
      <Table
        columns={TOLL_LIQUIDATION_ADDITIONAL_CHARGE_COLUMNS}
        data={tollLiquidationAdditionalChargeList}
        defaultPageSize={
          tollLiquidationAdditionalChargeList.length <= 10
            ? tollLiquidationAdditionalChargeList.length
            : DEFAULT_PAGE_SIZE
        }
        showPagination={tollLiquidationAdditionalChargeList.length > 10}
        manual={false}
        filterable
        defaultFilterMethod={filterMethodCaseInsensitive}
      />
    ) : (
      <div className="alert alert-info">
        No existen cargos adicionales registrados.
      </div>
    )}

    <h3 className="mt-4">Información interna</h3>

    <ResourceProperty label="ID: ">{id || '-'}</ResourceProperty>

    <ResourceProperty label="Itinerario ID: ">
      {itineraryId || '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Creación: ">
      {createDate
        ? tzNormalizeDate({
            date: createDate,
            format: DATE_TIME_FORMAT,
          })
        : '-'}
    </ResourceProperty>
  </>
);

TollLiquidationBasicInformationResource.propTypes = tollLiquidationPropTypes;

export default TollLiquidationBasicInformationResource;
